import { useFormikContext } from 'formik'

import { useKeyboard } from '../../../../hooks'
import { BUTTON_HEIGHT_40 } from '../../../Button'

export function useRentalPortalProfileBlockFormActions({
  buttonHeight = BUTTON_HEIGHT_40,
  isCloseConfirm,
  onCancel,
}) {
  const { dirty, isSubmitting } = useFormikContext()

  function handleCancel() {
    onCancel({ dirty })
  }

  function handleEscape() {
    if (!isCloseConfirm && !isSubmitting) {
      handleCancel()
    }
  }

  useKeyboard(null, handleEscape)

  return {
    actionsProps: {
      ButtonAdd: false,
      ButtonClear: false,
      Header: false,
      UploadComponent: false,
      cancelProps: {
        height: buttonHeight,
        onClick: handleCancel,
      },
      isSubmitting,
      submitProps: {
        disabled: !dirty,
        height: buttonHeight,
        isLoading: isSubmitting,
        title: 'Modal.SaveBtnKey',
      },
    },
  }
}
